module.exports = __webpack_public_path__ + "static/la-ventures--theo-verge-4553edc8d23dde08e7f95e81e1ae3970.mp4";